import React, { useEffect } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  change,
  Field,
  formValueSelector,
  getFormValues,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import BottomNavigation from "components/BottomNavigation"
import {
  getMetaTags,
  getPrivateMessage,
  getUsersBySearch,
  resetPrivateMessage,
  updatePrivateMessage,
} from "store/actions"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  RadioField,
} from "components/RenderInput"

const DmAccessControls = ({
  change,
  initializeForm,
  getUsersBySearch,
  usersBySearch,
  handleBack,
  formValues,
  metaTags,
  getPrivateMessage,
  getMetaTags,
  resetPrivateMessage,
  privateMessage,
  updatePrivateMessage,
  updateLoading
}) => {
  useEffect(() => {
    getPrivateMessage({
      id: -1,
      values: {},
    })
    getMetaTags({ hide_for_business_unit: 1 })
    return () => {
      resetPrivateMessage()
    }
  }, [])

  const handleSave = () => {
    const updatedData = {
      ...privateMessage,
      pm_setup_type: formValues?.receivers,
      receiveUsersTags:
        formValues?.receivers === "tags" ? formValues?.tagSearch : [],
      pmUsers: formValues?.receivers === "users" ? formValues?.userSearch : [],
      adminSetupEnabled: formValues?.adminSetupEnabled ? 1 : 0,
      admin_setup_type: formValues?.adminUsers,
      admin_users_setup_type: formValues?.adminReceivers,
      admins:
        formValues?.adminUsers === "users" ? formValues?.adminUserSearch : [],
      adminReceiveUsers:
        formValues?.adminReceivers === "users"
          ? formValues?.adminReceiverUserSearch
          : [],
      adminTags:
        formValues?.adminUsers === "tags" ? formValues?.adminTagSearch : [],
      adminReceiveUsersTags:
        formValues?.adminReceivers === "tags"
          ? formValues?.adminReceiverTagSearch
          : [],
      can_upload: formValues?.mediaUploadEnabled ? 1 : 0,
      media_upload_access_type: formValues?.mediaUsers,
      mediaUploadUsers:
        formValues?.mediaUsers === "users" ? formValues?.mediaUserSearch : [],
      tags: formValues?.mediaUsers === "tags" ? formValues?.mediaTagSearch : [],
      tag_ids:
        formValues?.mediaUsers === "tags"
          ? formValues?.mediaTagSearch?.map(tag => tag?.value)
          : [],
      user_ids: [],
    }
    updatePrivateMessage(updatedData)
  }

  useEffect(() => {
    if (privateMessage) {
      initializeForm({
        receivers: privateMessage?.pm_setup_type,
        tagSearch: privateMessage?.receiveUsersTags?.map(tag => ({
          ...tag,
          label: tag?.tag,
          value: tag?.id,
        })),
        userSearch: privateMessage?.pmUsers?.map(user => ({
          ...user,
          label: `${user.first_name} ${user.last_name} (${user.email})`,
          value: user.id,
        })),
        adminSetupEnabled:
          privateMessage?.admin_setup_type === "tags" ||
          privateMessage?.admin_setup_type === "users",
        adminUsers: privateMessage?.admin_setup_type,
        adminReceivers: privateMessage?.admin_users_setup_type,
        adminUserSearch: privateMessage?.admins?.map(user => ({
          ...user,
          label: `${user.first_name} ${user.last_name} (${user.email})`,
          value: user.id,
        })),
        adminReceiverUserSearch: privateMessage?.adminReceiveUsers?.map(
          user => ({
            ...user,
            label: `${user.first_name} ${user.last_name} (${user.email})`,
            value: user.id,
          })
        ),
        adminTagSearch: privateMessage?.adminTags?.map(tag => ({
          ...tag,
          label: tag?.tag,
          value: tag?.id,
        })),
        adminReceiverTagSearch: privateMessage?.adminReceiveUsersTags?.map(
          tag => ({
            ...tag,
            label: tag?.tag,
            value: tag?.id,
          })
        ),
        mediaUploadEnabled: privateMessage?.can_upload === 1,
        mediaUsers: privateMessage?.media_upload_access_type,
        mediaUserSearch: privateMessage?.mediaUploadUsers?.map(user => ({
          ...user,
          label: `${user.first_name} ${user.last_name} (${user.email})`,
          value: user.id,
        })),
        mediaTagSearch: privateMessage?.tags?.map(tag => ({
          ...tag,
          label: tag?.tag,
          value: tag?.id,
        })),
      })
    }
  }, [privateMessage])

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="mt-3">
          <h4>WHICH USER(S) CAN A PRIVATE MESSAGE BE SENT TO?</h4>
        </CardHeader>
        <CardBody className="shadow-sm py-1">
          <Row>
            <Col xs={12} className="my-1">
              <Field
                name="receivers"
                value="none"
                type="radio"
                label="None"
                component={RadioField}
              />
            </Col>
            <Col xs={12} className="my-1">
              <Field
                name="receivers"
                value="all"
                type="radio"
                label="All Users"
                component={RadioField}
              />
            </Col>
            <Col xs={12} className="my-1">
              <Field
                name="receivers"
                value="users"
                type="radio"
                label="Selected Users"
                component={RadioField}
              />
            </Col>
            <Col xs={12} className="my-1">
              <Field
                name="receivers"
                value="tags"
                type="radio"
                label="Selected Tags"
                component={RadioField}
              />
            </Col>
            {formValues?.receivers === "users" && (
              <Col xs={12} className="my-2">
                <Field
                  name="userSearch"
                  component={AsyncTypeahedSelect}
                  placeholder="Search for specific users"
                  options={usersBySearch.map(user => ({
                    ...user,
                    label: `${user.first_name} ${user.last_name} (${user.email})`,
                    value: user.id,
                  }))}
                  inlineValue={false}
                  onInputChange={text =>
                    getUsersBySearch({
                      t: text,
                      include_admins: true,
                    })
                  }
                  isMulti={true}
                  onMenuClose={() => {
                    getUsersBySearch({
                      include_admins: true,
                    })
                  }}
                />
              </Col>
            )}
            {formValues?.receivers === "tags" && (
              <Col xs={12} className="my-2">
                <Field
                  name="tagSearch"
                  placeholder="Enter tag"
                  component={AsyncTypeahedSelect}
                  options={metaTags.map(tag => ({
                    ...tag,
                    label: tag.tag,
                    value: tag.id,
                  }))}
                  isMulti={true}
                />
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <h4>SELECT A PRIVATE MESSAGE ADMIN(S)</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <Field
                name="adminSetupEnabled"
                component={CheckboxField}
                label={"SELECT A PRIVATE MESSAGE ADMIN(S)"}
                onChange={(event, newValue) => {
                  if (newValue) {
                    change("adminUsers", "users")
                    change("adminReceivers", "all")
                  } else {
                    change("adminUsers", "none")
                  }
                }}
              />
            </Col>
          </Row>
          {formValues?.adminSetupEnabled && (
            <>
              <Row className="mt-2">
                <Col xs={12} className="my-1">
                  <Field
                    name="adminUsers"
                    value="users"
                    type="radio"
                    label="Select user(s) to be PM Admin"
                    component={RadioField}
                  />
                </Col>
                <Col xs={12} className="my-1">
                  <Field
                    name="adminUsers"
                    value="tags"
                    type="radio"
                    label="Select tagged user(s) to be your PM Admin"
                    component={RadioField}
                  />
                </Col>
                {formValues?.adminUsers === "users" && (
                  <Col xs={12} className="my-2">
                    <Field
                      name="adminUserSearch"
                      component={AsyncTypeahedSelect}
                      placeholder="Search for specific users"
                      options={usersBySearch.map(user => ({
                        ...user,
                        label: `${user.first_name} ${user.last_name} (${user.email})`,
                        value: user.id,
                      }))}
                      inlineValue={false}
                      onInputChange={text =>
                        getUsersBySearch({
                          t: text,
                          include_admins: true,
                        })
                      }
                      isMulti={true}
                      onMenuClose={() => {
                        getUsersBySearch({
                          include_admins: true,
                        })
                      }}
                    />
                  </Col>
                )}
                {formValues?.adminUsers === "tags" && (
                  <Col xs={12} className="my-2">
                    <Field
                      name="adminTagSearch"
                      placeholder="Enter tag"
                      component={AsyncTypeahedSelect}
                      options={metaTags.map(tag => ({
                        ...tag,
                        label: tag.tag,
                        value: tag.id,
                      }))}
                      isMulti={true}
                    />
                  </Col>
                )}
              </Row>
              <Row className="mt-3">
                <Col xs={12}>
                  <h5>
                    To whom can a Private Message Admin send a private message
                    to?
                  </h5>
                </Col>
                <Col xs={12} className="my-1">
                  <Field
                    name="adminReceivers"
                    value="all"
                    type="radio"
                    label="All Users"
                    component={RadioField}
                  />
                </Col>
                <Col xs={12} className="my-1">
                  <Field
                    name="adminReceivers"
                    value="users"
                    type="radio"
                    label="Selected Users"
                    component={RadioField}
                  />
                </Col>
                <Col xs={12} className="my-1">
                  <Field
                    name="adminReceivers"
                    value="tags"
                    type="radio"
                    label="Selected Tags"
                    component={RadioField}
                  />
                </Col>
                {formValues?.adminReceivers === "users" && (
                  <Col xs={12} className="my-2">
                    <Field
                      name="adminReceiverUserSearch"
                      component={AsyncTypeahedSelect}
                      placeholder="Search for specific users"
                      options={usersBySearch.map(user => ({
                        ...user,
                        label: `${user.first_name} ${user.last_name} (${user.email})`,
                        value: user.id,
                      }))}
                      inlineValue={false}
                      onInputChange={text =>
                        getUsersBySearch({
                          t: text,
                          include_admins: true,
                        })
                      }
                      isMulti={true}
                      onMenuClose={() => {
                        getUsersBySearch({
                          include_admins: true,
                        })
                      }}
                    />
                  </Col>
                )}
                {formValues?.adminReceivers === "tags" && (
                  <Col xs={12} className="my-2">
                    <Field
                      name="adminReceiverTagSearch"
                      placeholder="Enter tag"
                      component={AsyncTypeahedSelect}
                      options={metaTags.map(tag => ({
                        ...tag,
                        label: tag.tag,
                        value: tag.id,
                      }))}
                      isMulti={true}
                    />
                  </Col>
                )}
              </Row>
            </>
          )}
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <h4>MEDIA UPLOAD</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <Field
                name="mediaUploadEnabled"
                component={CheckboxField}
                label={"Upload Media from Local Devices (photos & videos)"}
                onChange={(event, newValue) => {
                  if (newValue) {
                    change("mediaUsers", "all")
                  } else {
                    change("mediaUsers", "none")
                  }
                }}
              />
            </Col>
          </Row>
          {formValues?.mediaUploadEnabled && (
            <>
              <Row>
                <Col xs={12} className="my-1">
                  <Field
                    name="mediaUsers"
                    value="all"
                    type="radio"
                    label="All Users"
                    component={RadioField}
                  />
                </Col>
                <Col xs={12} className="my-1">
                  <Field
                    name="mediaUsers"
                    value="users"
                    type="radio"
                    label="Selected Users"
                    component={RadioField}
                  />
                </Col>
                <Col xs={12} className="my-1">
                  <Field
                    name="mediaUsers"
                    value="tags"
                    type="radio"
                    label="Selected Tags"
                    component={RadioField}
                  />
                </Col>
                {formValues?.mediaUsers === "users" && (
                  <Col xs={12} className="my-2">
                    <Field
                      name="mediaUserSearch"
                      component={AsyncTypeahedSelect}
                      placeholder="Search for specific users"
                      options={usersBySearch.map(user => ({
                        ...user,
                        label: `${user.first_name} ${user.last_name} (${user.email})`,
                        value: user.id,
                      }))}
                      inlineValue={false}
                      onInputChange={text =>
                        getUsersBySearch({
                          t: text,
                          include_admins: true,
                        })
                      }
                      isMulti={true}
                      onMenuClose={() => {
                        getUsersBySearch({
                          include_admins: true,
                        })
                      }}
                    />
                  </Col>
                )}
                {formValues?.mediaUsers === "tags" && (
                  <Col xs={12} className="my-2">
                    <Field
                      name="mediaTagSearch"
                      placeholder="Enter tag"
                      component={AsyncTypeahedSelect}
                      options={metaTags.map(tag => ({
                        ...tag,
                        label: tag.tag,
                        value: tag.id,
                      }))}
                      isMulti={true}
                    />
                  </Col>
                )}
              </Row>
            </>
          )}
        </CardBody>
      </Card>
      <BottomNavigation handleBack={handleBack} handleSave={handleSave} loading={updateLoading} />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PLATFORM_SETTINGS)

const mapStateToProps = state => ({
  formValues: getFormValues(FORM_NAMES.DM_ACCESS_CONTROLS)(state),
  usersBySearch: state.SiteUsers.usersBySearch,
  metaTags: state.Tags.metaTags,
  privateMessage: state.PrivateMessage.privateMessage,
  updateLoading: state.PrivateMessage.updateLoading,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PLATFORM_SETTINGS, `${field}`, value)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.DM_ACCESS_CONTROLS, values)),
  getPrivateMessage: values => dispatch(getPrivateMessage(values)),
  resetPrivateMessage: () => dispatch(resetPrivateMessage()),
  getMetaTags: values => dispatch(getMetaTags(values)),
  updatePrivateMessage: values => dispatch(updatePrivateMessage(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.DM_ACCESS_CONTROLS })(DmAccessControls))
